import React, {useContext, useEffect} from "react";
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import {setLookOverlayOpened} from "../../../../actions/lookFunctions";
import {getCommonVisualizerType, IS_QKB_UI} from "../../../../config";
import LookAIPopupDropZone from "./LookAIPopupDropZone";
import LookAIPopupGeneratedImages from "./LookAIPopupGeneratedImages";
import {getLookList} from "../../../look/lookNavigation/lookFunctions";
import LookAiPopupContext from "./LookAiPopupContext";
import LookAIPopupFeatureGroups from "./LookAIPopupFeatureGroups";
import {setLookAiExportData} from "../../aiActions";
import {getAIInitialGroups} from "../../aiFunctions";
import {getAIGlobalSettings} from "../../aiAsyncActions";
import {updateLocalStorage} from "../../../../misc/jobLocalStorageSave";


const LookAIPopupContent = (props) => {

  const {setLookOverlayOpened, intl, visualizersLoadedLength, showLeadOverlay, isMobile, aiSettings, fabricatorData,
    visualizerIsChanging, setLookAiExportData, aiImportData, getAIGlobalSettings} = props;

  const {lookAiPopupDispatch} = useContext(LookAiPopupContext);

  const closeAIPopup = () => {
    setLookOverlayOpened("");
  }

  const visualizerTypeTranslate = intl.formatMessage({id: "rooms." + getCommonVisualizerType()});

  const setInitialAiLogic = () => {
    const lookList = getLookList();
    if (!visualizersLoadedLength || (!lookList && !aiSettings.aiGroups)) {
      return
    }
    const newGroupObjects = getAIInitialGroups(aiImportData, aiSettings)
    lookAiPopupDispatch({
      // userFile: null,
      groupObjects: newGroupObjects,
    });
    setLookAiExportData(newGroupObjects); // keep groupObjects only, we will update export object on save, no need to store
    updateLocalStorage();
  }

  useEffect(() => {
    setInitialAiLogic();
    getAIGlobalSettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visualizersLoadedLength, visualizerIsChanging]);

  return (
    <div className="look-ai__content u-w-full u-p-1 bg-white flex--1 scrollable">
      <div className="flex flex--center flex--between u-mb-05 u-mt-05">
        <h2 className={"bold font--16 u-m-0" + (IS_QKB_UI ? " color-primary" : "")}>
          <FormattedMessage id={"look.ai.panel.title"} values={{
            visualizerType: visualizerTypeTranslate,
          }}/>
        </h2>
        <IconButton aria-label={intl.formatMessage({id: "iconButton.close"})}
                    className="look-icon look-icon--small"
                    onClick={closeAIPopup}>
          <CloseIcon/>
        </IconButton>
      </div>
      <div className="font--12 u-leading-1 look-ai__panel-text u-mb-1">
        {isMobile ? (
          <FormattedMessage id="look.ai.panel.mobile.subTitle"
                            values={{
                              visualizerType: visualizerTypeTranslate
                            }}/>
        ) : (
          <div className="flex u-gap-05 flex--top">
            <div className="border border-solid rounded-full color-secondary_active border-secondary_active bold
            flex flex--center font--18 w-[26px] h-[26px] flex-[0_0_26px]">!</div>
            <div className="flex flex--column flex--top flex--start u-gap-05">
              <p className="u-m-0">
                <span className="bold"><FormattedMessage id="look.ai.panel.step"/> 1. </span>
                <FormattedMessage id="look.ai.panel.subTitle"/>
              </p>
              <p className="u-m-0">
                <span className="bold"><FormattedMessage id="look.ai.panel.step"/> 2. </span>
                <FormattedMessage id="look.ai.panel.subTitle2" values={{
                  visualizerType: visualizerTypeTranslate
                }}/>
              </p>
            </div>
          </div>
        )}
      </div>
      <LookAIPopupDropZone/>
      <LookAIPopupGeneratedImages showLeadOverlay={showLeadOverlay}/>
      <LookAIPopupFeatureGroups intl={intl} fabricatorData={fabricatorData} setLookAiExportData={setLookAiExportData}/>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {lookOverlayOpened} = store.lookState;
  const {visualizersLoaded, isMobile, visualizerIsChanging} = store.serverState;
  const {aiSettings} = store.fabricatorState;
  const fabricatorData = store.fabricatorState;
  const {aiImportData} = store.aiState;

  return {
    lookOverlayOpened,
    visualizersLoadedLength: visualizersLoaded.length,
    isMobile,
    fabricatorData,
    aiSettings,
    visualizerIsChanging,
    aiImportData,
  };
};

const mapDispatchToProps = {
  setLookOverlayOpened,
  setLookAiExportData,
  getAIGlobalSettings,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookAIPopupContent)
)
